var _excluded = ["children", "i18nScope", "showLabel"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { useI18nContext } from '../_hooks/I18n';
import { StyledRequiredContainer, StyledRequiredMark, StyledRequiredText } from './Required.styles';
/**

 @since 10.19.0

 @see [Storybook](https://stories.core.procore.com/?path=/story/core-react_demos-required--demo)

 */
export var Required = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$i18nScope = _ref.i18nScope,
    i18nScope = _ref$i18nScope === void 0 ? 'core.required' : _ref$i18nScope,
    _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? false : _ref$showLabel,
    props = _objectWithoutProperties(_ref, _excluded);
  var I18n = useI18nContext();
  var labelOrChildren = showLabel || Boolean(children);
  return /*#__PURE__*/React.createElement(StyledRequiredContainer, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(StyledRequiredMark, {
    $showLabel: labelOrChildren
  }, "*"), labelOrChildren ? /*#__PURE__*/React.createElement(StyledRequiredText, null, children ? children : I18n.t('requiredFields', {
    scope: i18nScope
  })) : null);
});
Required.displayName = 'Required';
//# sourceMappingURL=Required.js.map